import { useEffect, useState } from 'react';
import ContactForm from './ContactForm';
import { CONTACT_PREFILL_EVENT } from '../utils/contactPrefill';

const GetintouchandContact = () => {
  const [prefill, setPrefill] = useState({ subject: '', message: '' });

  useEffect(() => {
    const handlePrefill = (event) => {
      setPrefill({
        subject: event.detail?.subject || '',
        message: event.detail?.message || '',
      });
    };

    window.addEventListener(CONTACT_PREFILL_EVENT, handlePrefill);
    return () => window.removeEventListener(CONTACT_PREFILL_EVENT, handlePrefill);
  }, []);

  return (
    <div
      className="modal fade"
      id="getintouchandcontct"
      tabIndex="-1"
      aria-labelledby="contactModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg">
        <div
          className="modal-content"
          style={{
            border: 'none',
            borderRadius: '12px',
            boxShadow: '0 25px 80px rgba(0, 0, 0, 0.18)',
            background: 'var(--bg-secondary)',
          }}
        >
          <div
            style={{
              background: 'rgba(26, 43, 74, 0.02)',
              borderRadius: '10px',
              margin: '8px',
              border: '1px solid var(--border-color)',
            }}
          >
            <div
              className="modal-header border-0"
              style={{ padding: '36px 36px 16px 36px' }}
            >
              <div>
                <h3
                  className="modal-title"
                  id="contactModalLabel"
                  style={{
                    color: 'var(--text-primary)',
                    fontWeight: '700',
                    fontSize: '1.8rem',
                    margin: '0 0 0.4rem',
                    letterSpacing: '-0.02em',
                  }}
                >
                  Let's talk
                </h3>
                <p
                  style={{
                    color: 'var(--text-secondary)',
                    fontSize: '0.95rem',
                    lineHeight: '1.6',
                    margin: 0,
                  }}
                >
                  Curious about our work, exploring a partnership, or just want to say hello?
                </p>
              </div>
              <button
                type="button"
                className="btn-close ms-auto"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body" style={{ padding: '8px 36px 36px' }}>
              <ContactForm
                idPrefix="modal"
                presetSubject={prefill.subject}
                presetMessage={prefill.message}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetintouchandContact;
